// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3140":"f4f55507","4726":"f608559a","6950":"36e43ea4","7834":"3426305a","8688":"85a95858"}[chunkId] + ".chunk.css";
};